import { useTranslation } from "react-i18next"

import { DebouncedSearchInput } from "@/components/shared/debounced-search-input"

/**
 * OKS-17 — Search input for the candidate list.
 *
 * Thin wrapper around `<DebouncedSearchInput>` (extracted to
 * `components/shared/` in OKS-25 so the same UX is reused across list
 * pages without duplicating the debounce + spinner logic). All
 * mechanics live in the shared component; this wrapper supplies the
 * candidate-list-specific testid + i18n keys.
 *
 * Locked testid: `candidate-list-search` (UX Spec freeze, OKS-17 v4).
 */
interface CandidateSearchInputProps {
  defaultValue: string
  onDebouncedChange: (value: string) => void
  delayMs?: number
  className?: string
}

export function CandidateSearchInput({
  defaultValue,
  onDebouncedChange,
  delayMs,
  className,
}: CandidateSearchInputProps) {
  const { t } = useTranslation()

  return (
    <DebouncedSearchInput
      defaultValue={defaultValue}
      onDebouncedChange={onDebouncedChange}
      delayMs={delayMs}
      className={className}
      testId="candidate-list-search"
      ariaLabel={t("candidates.list.search_aria")}
      placeholder={t("candidates.list.search_placeholder")}
    />
  )
}
